<template>
  <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <span class="tool-bar">
      <!-- 主题切换 -->
      <theme-picker style="float:right;" class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
      <!-- 语言切换 -->
      <lang-selector class="lang-selector"></lang-selector>
    </span>
    <h2 class="title" style="padding-left:22px;" >{{ appName }}</h2>
    <el-form-item prop="account">
      <el-input type="text" v-model="loginForm.account" auto-complete="off" :placeholder="$t('user.account')"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="loginForm.password" auto-complete="off" :placeholder="$t('user.password')"></el-input>
    </el-form-item>
 
    <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:48%;" @click.native.prevent="reset">{{$t('common.reset')}}</el-button>
      <el-button type="primary" style="width:48%;" @click.native.prevent="login" :loading="loading">{{$t('common.login')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
import { login as loginAction } from '@/api/ydstrong'
import md5 from 'js-md5';


export default {
  name: 'Login',
  components:{
    ThemePicker,
    LangSelector
  },
  data() {
    return {
      appName:Vue.prototype.appName,
      loading: false,
      loginForm: {
        //account: 'emsAdmin',//测试经销商意大利HINTIME   AdminITALYHINTIME   emsAdminITALY emsAdminJP
        //password: '123ems456'       
        account: '',
        password: ''       
      },
      fieldRules: {
        account: [
          { required: true, message: 'Please enter the account', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter the password', trigger: 'blur' }
        ]
        // ,
        // captcha: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
      },
      checked: true
    }
  },
  methods: {
    login() {
      this.loading = true
      let userInfo = {phone:this.loginForm.account, pwd: md5(this.loginForm.password)}
      loginAction(userInfo).then((res) => {
        debugger
          if(res.status != 0) {
            this.$message({
              message: res.msg ? res.msg : this.$t('elLocal.loginFail'),
              type: 'error'
            })
          } else {
            debugger
            Cookies.set('token', res.data.token) // 放置token到Cookie
            sessionStorage.setItem('user', JSON.stringify(res.data.user)) // 保存用户到本地会话
            this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
            this.$router.push('/')  // 登录成功，跳转到主页
          }
          this.loading = false
        }).catch((res) => {
          this.$message({
          message: res.data ? res.data : res.message,
          type: 'error'
          })
        });
    },
    refreshCaptcha: function(){
      console.log(process.env.API_ROOT)
      this.loginForm.src = "/sjtyApi/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor
    })
  }
}
</script>

<style lang="scss" scoped>
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Login.vue